import React from 'react';
import { observer, inject } from 'mobx-react';

import { formatCurrency } from 'js/services/Format';

import Row from 'js/components/core/ReviewPanel/Row';
import Label from 'js/components/core/ReviewPanel/Label';
import Content from 'js/components/core/ReviewPanel/Content';
import EditButton from 'js/components/core/ReviewPanel/EditButton';

import Container from './Container';
import Price from './Price';
import Address from './Address';
import ShippingSummary from './ShippingSummary';
import CreditCard from './CreditCard';

export default inject('page')(
  observer(({ page }) => (
    <Container>
      <Row>
        <Label>BUYER</Label>
        <Content>@{page.purchase_token.buyer}</Content>
      </Row>

      <Row>
        <Label>ITEM</Label>
        <Content>
          <div>{page.purchase_token.title}</div>
          <Price>{formatMoney(page.purchase_token.price, 0)}</Price>
        </Content>
      </Row>

      <Row hasError={!page.address.hasAddress || !page.shipping_quote}>
        <Label>{page.shipping_quote.isSameDay ? 'PICK UP' : 'SHIPPING'}</Label>
        <Content>
          {page.shipping_quote.isSameDay && <Address />}
          <ShippingSummary />
        </Content>
      </Row>

      {/*<Row hasError={!page.credit_card.isFilledIn} errorColor="#eef2ff" onClick={page.editPaymentMethod}>*/}
      {/*  <Label>CARD</Label>*/}
      {/*  <Content>*/}
      {/*    <CreditCard />*/}
      {/*  </Content>*/}
      {/*  <EditButton />*/}
      {/*</Row>*/}
    </Container>
  )),
);
